(function () {
  var FEROMONA_VARIANTS = {
    '5 Gotas':  54171121484105,
    '10 Gotas': 54169020858697,
    '15 Gotas': 54169020891465,
    '20 Gotas': 54169020924233
  };

  function init() {
    var select = document.getElementById('feromona-select');
    if (!select) return;

    var badge = document.getElementById('feromona-badge');
    var badgeText = document.getElementById('feromona-badge-text');

    function getPriceEl() {
      var saleContainer = document.querySelector('.price__sale');
      var regularContainer = document.querySelector('.price__regular');
      if (saleContainer && getComputedStyle(saleContainer).display !== 'none') {
        return saleContainer.querySelector('.price-item--sale.price-item--last') ||
               saleContainer.querySelector('.price-item');
      }
      if (regularContainer && getComputedStyle(regularContainer).display !== 'none') {
        return regularContainer.querySelector('.price-item--regular') ||
               regularContainer.querySelector('.price-item');
      }
      return document.querySelector('.price-item--regular') ||
             document.querySelector('.price-item');
    }

    function parseCents(el) {
      if (!el) return 0;
      var text = el.textContent.replace(/[€\s]/g, '').replace('EUR', '').trim();
      var m = text.match(/(\d+)[,.](\d+)/);
      return m ? parseInt(m[1], 10) * 100 + parseInt(m[2], 10) : 0;
    }

    function fmtPrice(cents) {
      return '€' + Math.floor(cents / 100) + ',' + ('0' + (cents % 100)).slice(-2) + ' EUR';
    }

    var baseCents = parseCents(getPriceEl());

    function applyPrice() {
      var opt = select.options[select.selectedIndex];
      var extra = parseInt(opt.getAttribute('data-price') || '0', 10);
      var isFree = opt.getAttribute('data-free') === 'true';
      var val = opt.value;
      var el = getPriceEl();
      if (!el || !baseCents) return;

      if (val === '') {
        el.textContent = fmtPrice(baseCents);
        badge.style.display = 'none';
      } else if (isFree) {
        el.textContent = fmtPrice(baseCents);
        badgeText.textContent = '5 Gotas de Feromonas incluidas gratis ✨';
        badge.style.display = 'block';
      } else {
        el.textContent = fmtPrice(baseCents + extra);
        badgeText.textContent = '+' + (extra / 100).toFixed(2).replace('.', ',') + ' € por feromonas';
        badge.style.display = 'block';
      }
    }

    select.addEventListener('change', applyPrice);

    var radios = document.querySelectorAll('input[type="radio"]');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        select.selectedIndex = 0;
        badge.style.display = 'none';
        setTimeout(function () {
          baseCents = parseCents(getPriceEl());
        }, 600);
      });
    });

    var form = document.querySelector('form[action="/cart/add"]');
    var btn = document.querySelector('.product-form__submit, [name="add"]');

    if (form && btn) {
      btn.addEventListener('click', function (e) {
        var val = select.options[select.selectedIndex].value;
        if (!val || !FEROMONA_VARIANTS[val]) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        var variantInput = form.querySelector('[name="id"]');
        var quantityInput = form.querySelector('[name="quantity"]');
        var perfumeVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
        if (!perfumeVariantId) return;

        btn.disabled = true;

        var items = [
          { id: perfumeVariantId, quantity: quantity, properties: { 'Feromonas': val } },
          { id: FEROMONA_VARIANTS[val], quantity: quantity }
        ];

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(resp) { return resp.json(); })
        .then(function() {
          return fetch('/?sections=cart-drawer,cart-icon-bubble');
        })
        .then(function(resp) { return resp.json(); })
        .then(function(sections) {
          var cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer) return;

          if (sections['cart-drawer']) {
            var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var shopifySection = parsed.querySelector('.shopify-section');
            var cartDrawerEl = document.getElementById('CartDrawer');
            if (shopifySection && cartDrawerEl) {
              cartDrawerEl.innerHTML = shopifySection.innerHTML;
            }
          }

          if (sections['cart-icon-bubble']) {
            var parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var newBubble = parsedBubble.querySelector('.cart-count-bubble');
            var bubbleEl = document.getElementById('cart-icon-bubble');
            if (bubbleEl && newBubble) {
              var curBubble = bubbleEl.querySelector('.cart-count-bubble');
              if (curBubble) curBubble.innerHTML = newBubble.innerHTML;
              else bubbleEl.appendChild(newBubble);
            }
          }

          var overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay) {
            overlay.replaceWith(overlay.cloneNode(true));
            document.getElementById('CartDrawer-Overlay').addEventListener('click', cartDrawer.close.bind(cartDrawer));
          }

          btn.disabled = false;

          requestAnimationFrame(function() {
            cartDrawer.classList.remove('is-empty');
            var di = cartDrawer.querySelector('.drawer__inner');
            if (di) di.classList.remove('is-empty');
            var cdi = cartDrawer.querySelector('cart-drawer-items');
            if (cdi) cdi.classList.remove('is-empty');
            // Simular click en icono carrito — abre con contenido actualizado
            var cartIcon = document.getElementById('cart-icon-bubble');
            if (cartIcon) {
              cartIcon.click();
            } else {
              cartDrawer.open(btn);
            }
          });
        })
        .catch(function() { btn.disabled = false; });
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Botón feromonas en el drawer (sin cambios)
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.feromona-drawer-btn');
  if (!btn) return;

  btn.disabled = true;
  btn.style.background = '#ccc';
  btn.textContent = '⏳ Añadiendo...';

  fetch('/cart.js')
    .then(cartResp => cartResp.json())
    .then(cart => {
      const perfume = cart.items.find(item => item.product_id !== 10142600593737);
      if (!perfume) return;
      const newProperties = Object.assign({}, perfume.properties, { 'Feromonas': '5 Gotas (gratis)' });
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: perfume.key, quantity: perfume.quantity, properties: newProperties })
      });
    })
    .then(() => {
      btn.style.background = '#25D366';
      btn.textContent = '✅ ¡5 Gotas añadidas al perfume!';
      fetch('/?sections=cart-drawer')
        .then(resp => resp.json())
        .then(data => {
          if (data['cart-drawer']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
            const newDrawer = doc.querySelector('#CartDrawer');
            const currentDrawer = document.querySelector('#CartDrawer');
            if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
          }
        });
    })
    .catch(() => {
      btn.disabled = false;
      btn.style.background = '#25D366';
      btn.textContent = '🧪 AÑADIR GRATIS — 5 Gotas de Feromona';
    });
});
